type ALLOWED_LOCALES = 'en-US' | 'en-CA' | 'fr-CA' | undefined;

export const formatCurrency = (amount : number, locale? : ALLOWED_LOCALES) => {

    if (locale === undefined) {
        locale = 'en-US';
    }

    const getCurrenyString = (l : ALLOWED_LOCALES) => {
        switch (l){
            case 'en-CA':
            case 'fr-CA':
                return 'CAD';
            case 'en-US':
            default:
                return 'USD';
        }
    };

    const formatter = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: getCurrenyString(locale),
        minimumFractionDigits: 2
    });
  
    const val = formatter.format(amount);
    
    if (getCurrenyString(locale) === 'CAD') {
        const regex = /\$/gi;
        return val.replace(regex, 'C$');
    }
    else {
        return val;
    }

};
